import { render, staticRenderFns } from "./GettingStartedInvestigationItem.vue?vue&type=template&id=2b33b49c&"
import script from "./GettingStartedInvestigationItem.vue?vue&type=script&lang=js&"
export * from "./GettingStartedInvestigationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports